import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../config/AuthContext";
import { ROUTES } from "../config/routes";
import { categories } from "../config/categories";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Typography,
  Grid,
  Paper,
  Chip,
} from "@material-ui/core";

import Hero from "../heroImage.svg";

const useStyles = makeStyles((theme) => ({
  homePageLeftSection: {
    padding: theme.spacing(1),
    background: theme.palette.background.paper,
  },
  homePageMiddleSection: {
    background: theme.palette.background.paper,
  },
  middleSectionContent: {
    padding: theme.spacing(1),
    background: theme.palette.background.paper,
  },
  heroImage: {
    marginTop: theme.spacing(3),
    minHeight: "300px",
    width: "100%",
    background: `url(${Hero})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPostion: "center",
  },
  heroImageLayover: {
    padding: theme.spacing(2),
    minHeight: "350px",
    borderRadius: "0.25rem",
    background: `rgba(0,0,0, 0.25)`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  heroImagePrimaryText: {
    color: theme.palette.primary.contrastText,
    fontWeight: "900",
    fontSize: "3.5rem",
  },
  heroImageSecondaryText: {
    color: theme.palette.primary.contrastText,
    fontWeight: "900",
    fontSize: "1.5rem",
  },
  categoriesChipsContainer: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },

  categoryChip: {
    margin: theme.spacing(0.5),
  },
  blogListGrid: {
    padding: theme.spacing(5, 1),
  },
  noBlogsText: {
    color: theme.palette.text.secondary,
    fontWeight: "900",
    fontSize: "3.5rem",
  },
  blogCard: {
    border: `2px solid ${theme.palette.primary.dark}`,
    boxShadow: `7px 7px 2px ${theme.palette.primary.shadow}`,
    cursor: "pointer",
  },
  blogCardHeader: {
    textAlign: "center",
  },
  blogCardHeaderBadge: {
    color: theme.palette.primary.dark,
  },
  blogCardContent: {
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  blogCardContent_Title: {
    fontWeight: "900",
  },
  blogCardActions: {
    justifyContent: "space-between",
  },
  blogCardChip: {
    background: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
  },
  blogCardButton: {
    color: theme.palette.text.secondary,
    fontWeight: "600",
  },
  homePageRightSection: {
    padding: theme.spacing(1),
    background: theme.palette.background.paper,
  },
}));

const Home = () => {
  const { dbRef } = useAuth();
  const classes = useStyles();
  const history = useHistory();
  const [category, setCategory] = useState("All");

  const [blogsSnapshot, setBlogsSnapshot] = useState([]);
  let blogs = [];

  useEffect(() => {
    const unsubscribe =
      category === "All"
        ? dbRef.child("blogs").on("value", (snapshot) => {
            setBlogsSnapshot(snapshot);
          })
        : dbRef
            .child("blogs")
            .orderByChild("BlogCategory")
            .equalTo(category)
            .on("value", (snapshot) => {
              setBlogsSnapshot(snapshot);
            });
    return unsubscribe;
  }, [category]);

  blogsSnapshot.forEach((child) => {
    blogs.push(child);
  });

  const blogsList =
    blogs.length > 0 ? (
      blogs.map((blog, index) => {
        return (
          <Grid item xs={12} sm={6} md={4} xl={4} key={index}>
            {/* <Grid item key={index}> */}
            <Card
              className={classes.blogCard}
              onClick={() => history.push(`${ROUTES.HOME}/${blog.key}`)}
            >
              <CardHeader className={classes.blogCardHeader} />
              <CardContent className={classes.blogCardContent}>
                <Typography
                  variant="h5"
                  component="h5"
                  fontWeight={800}
                  className={classes.blogCardContent_Title}
                >
                  {blog.val().BlogTitle}
                </Typography>
                <Typography variant="body2" component="p">
                  {Math.ceil(blog.val().BlogPost.split(" ").length / 200)} min
                  read
                </Typography>
              </CardContent>
              <CardActions className={classes.blogCardActions}>
                <Chip
                  size="small"
                  label={blog.val().BlogCategory}
                  className={classes.blogCardChip}
                />
                <Button
                  size="small"
                  // onClick={() => history.push(`${ROUTES.HOME}/${blog.key}`)}
                  className={classes.blogCardButton}
                >
                  Read...
                </Button>
              </CardActions>
            </Card>
          </Grid>
        );
      })
    ) : (
      <Grid item xs={12} sm={12} md={12} xl={12}>
        <Typography className={classes.noBlogsText}>
          We're working on blogs in this category. Please do checkout other
          blogs.
        </Typography>
      </Grid>
    );

  const handleCategorySelect = (selectedCategory, index) => {
    // console.log(`Category : ${selectedCategory} was clicked!!`);
    setCategory(selectedCategory);
  };
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={2}
        className={classes.homePageLeftSection}
      ></Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={8}
        className={classes.homePageMiddleSection}
      >
        <Paper elevation={0} className={classes.middleSectionContent}>
          <Paper className={classes.heroImage} elevation={4}>
            <div className={classes.heroImageLayover}>
              <div>
                <Typography className={classes.heroImagePrimaryText}>
                  Maadhyam.
                </Typography>
                {/* <em className={classes.heroImageSecondaryText}>
                  Your medium to knowledge.
                </em> */}
              </div>

              <Typography className={classes.heroImageSecondaryText}>
                Read. Learn. Grow.
              </Typography>
            </div>
          </Paper>

          <div className={classes.categoriesChipsContainer}>
            <Chip
              variant={category !== "All" ? "outlined" : "default"}
              color="secondary"
              clickable
              label="All Blogs"
              onClick={() => handleCategorySelect("All")}
              className={classes.categoryChip}
            />
            {categories.map((categoryItem, index) => (
              <Chip
                variant={
                  category !== categoryItem.title ? "outlined" : "default"
                }
                color="secondary"
                clickable
                key={index}
                label={categoryItem.title}
                onClick={() => handleCategorySelect(categoryItem.title, index)}
                className={classes.categoryChip}
              />
            ))}
          </div>
          <Grid container spacing={3} className={classes.blogListGrid}>
            {blogsList}
          </Grid>
        </Paper>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={2}
        className={classes.homePageRightSection}
      ></Grid>
    </Grid>
  );
};

export default Home;
